import { LatLng } from 'leaflet';

export const calculateCentroid = (coordinates: [number, number][]): LatLng | null => {
  if (coordinates.length === 0) {
    return null; // Handle the case when there are no coordinates
  }

  let totalLat = 0.0;
  let totalLon = 0.0;

  for (const [lon, lat] of coordinates) {
    totalLat += lat;
    totalLon += lon;
  }

  const n = coordinates.length;
  const centroidLat = totalLat / n;
  const centroidLon = totalLon / n;

  return new LatLng(centroidLat, centroidLon);
};
